import { useState } from 'react'

import logo from '.././../assets/logo.png'
import { CheckEmailForm } from './components/checkEmailForm'
import { CompleteRegisterForm } from './components/completeRegisterForm'

export function HaveNoPassword() {
  const [userId, setUserId] = useState<string | undefined>()

  function handleCheckEmailSubmit(userId: string) {
    setUserId(userId)
  }

  return (
    <div className="flex min-h-[100vh] w-[100vw] flex-1 flex-col justify-center items-center pb-24 pt-8">
      <div className="max-w-md sm:w-[90vw]">
        <div className="flex flex-col flex-1 justify-center items-center w-full">
          <img
            src={logo}
            alt="Logo"
          />
          <span className="text-center font-semibold mt-4">Relatórios de Trademarketing</span>
          <h3 className="text-center mt-9 text-2xl/9 font-bold tracking-tight text-gray-900">
            {!userId
              ? 'Insira o email cadastrado'
              : 'Complete seu cadastro'}

          </h3>
        </div>

        <div className="mt-10 w-full">
          {!userId
            ? <CheckEmailForm onSubmit={handleCheckEmailSubmit} />
            : <CompleteRegisterForm userId={userId} />}
        </div>
      </div>
    </div>
  )
}
